import { apiPath } from '../../constants';
import { COMPETITIONS_PATCH_SUCCESS } from '../Competition/patchAction';
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';

// The categories chosen, as the server answered — the rows in the store take
// them without re-reading the whole list (20 Oct 2026: with ~500 categories
// every tick re-read them all, and the card lagged).
export const MSAC_CONSOLIDATED_SAVE_SUCCESS = 'MSAC_CONSOLIDATED_SAVE_SUCCESS';

/**
 * THE MSAC CONSOLIDATED REPORT'S SHEETS — every category chosen, and the
 * region switch, in one request (15 Oct 2026). Both are read back from the
 * server: the category rows take the categories it answered, and the competition in the store
 * takes the `regions` the server answered — nothing is flipped locally.
 * `regions` left undefined is not sent, and the server leaves it as it is;
 * `countries` (a sheet per country, 20 Oct 2026) the same way.
 * Resolves true when saved.
 */
export const saveMsacConsolidatedCategories = (competition, categories, { regions, countries, record } = {}) => dispatch => axios(apiRequestOptions(
    apiPath.COMPETITION_CATEGORY.MSAC_CONSOLIDATED,
    {
        categories,
        ...(undefined === regions ? {} : { regions }),
        ...(undefined === countries ? {} : { countries }),
    },
    { params: { competition } },
))
    .then(transformHttpResponse)
    .then(response => {
        dispatch({ type: MSAC_CONSOLIDATED_SAVE_SUCCESS, competition, categories: response.data.categories || [] });
        if (record && response && response.data) {
            dispatch({
                type: COMPETITIONS_PATCH_SUCCESS,
                competition: {
                    ...record,
                    consolidatedRegionSheets: !!response.data.regions,
                    consolidatedCountrySheets: !!response.data.countries,
                },
            });
        }

        return true;
    })
    .catch(error => transformHttpResponse(error.response))
    .catch(error => {
        dispatch(errorRequestHandler(error));

        return false;
    });
